// FIXME: There is an issue when the Apollo cache is updated. useQuery will return updated results for the first few renders, then will return OLD data on the final render.
// This causes nextVariables of a feed request to be reset, breaking the infinite scroll feed.
// This appears to be an issue with Apollo Client. This useQuery abstraction was disabled, useQuery was called directly, and the issue still presented itself.
// Depending on which feed items are deleted, onFlatlistEndReached can be triggered.

import { useQuery as useQ } from "@apollo/client";

export const useQuery = (configuration, options = {}) => {
  const { query, buildOptions, buildResult } = configuration;
  const opts = buildOptions ? buildOptions(options) : options;

  const result = useQ(query, opts);

  if (result && buildResult) {
    Object.assign(result, buildResult(result));
  }
  return result;
};
